import type { TeamTypePlayPlayersLimitType } from '@genially/commons';

import {
  createPlayApiClient,
  playApiClient,
  shouldUseIndexedServerUrls,
} from './playApiClient';

export interface GetPlayPlayersLimitInfoResponse {
  limitPerMonth: {
    limit: TeamTypePlayPlayersLimitType;
    consumed: number;
    isLimitReached: boolean;
  };
  limitPerSession: number;
}

export const getPlayPlayersLimitInfo = async ({
  teamId,
  baseUrl,
}: {
  teamId: string;
  baseUrl?: string;
}): Promise<GetPlayPlayersLimitInfoResponse> => {
  const client = baseUrl
    ? createPlayApiClient({
        baseUrl: shouldUseIndexedServerUrls ? `${baseUrl}/0` : baseUrl,
      })
    : playApiClient;

  return client
    .get(`play/players-limit?teamId=${teamId}`)
    .then(response => response.data);
};
